const importAll = r => {
  let images = {};
  r.keys().forEach(key => {
    const fileName = key.replace('./', ''); // Remove './' from the file name
    images[fileName] = r(key); // Add image to the object with its file name as the key
  });
  return images;
};

// Use require.context to dynamically require all images in the folder
const images = importAll(require.context('../images', false, /\.(png|jpe?g|svg)$/));

export default images;
